import type { InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import { featureFlags } from '../config/feature-flags';

export const loggerInterceptor = {
  request: (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    if (featureFlags.httpLoggingEnabled) {
      console.log('[HTTP Request]', {
        method: config.method?.toUpperCase(),
        url: config.url,
        baseURL: config.baseURL,
        headers: config.headers,
        data: config.data,
      });
    }
    return config;
  },

  response: (response: AxiosResponse): AxiosResponse => {
    if (featureFlags.httpLoggingEnabled) {
      console.log('[HTTP Response]', {
        status: response.status,
        statusText: response.statusText,
        url: response.config.url,
        data: response.data,
      });
    }
    return response;
  },
};
